import classNames from "classnames";
import React, { ReactElement, useContext, useEffect, useState } from "react";
import Button from "../button";
import { FilterFooterProps } from "./filter.types";
import { FilterContext } from "./util/filterContext";
import { FilterApplyButtonMobileCss } from "./css-overrides";

const FilterFooter = ({
  isShowMoreFiltersActive,
  onToggleMoreFiltersClick,
  onApplyFiltersInternal,
  showMoreFiltersText = "View More",
  showFewerFiltersText = "View Less",
  withApplyButton,
  filterModulesCount,
  showFewFiltersCountInternal,
  applyButtonText = "Apply",
  footerButtons,
}: FilterFooterProps): ReactElement => {
  const { isXsScreen } = useContext(FilterContext);
  const sentinelRef = React.useRef<HTMLDivElement>(null);
  const [isFloating, setIsFloating] = useState(false);

  const viewMoreClasses = classNames("spark-filter__view-more-filters", {
    hide: isShowMoreFiltersActive,
  });
  const viewLessClasses = classNames("spark-filter__view-less-filters", {
    hide: !isShowMoreFiltersActive,
  });

  const applyButtonClasses = classNames(
    "spark-filter__btn-apply",
    "spark-btn-group-primary",
    "spark-btn--block-xs"
  );

  useEffect(() => {
    if (!isXsScreen || !sentinelRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFloating(entry.intersectionRatio < 1);
      },
      {
        threshold: [1],
        rootMargin: "0px 0px 0px 0px",
      }
    );

    observer.observe(sentinelRef.current);

    return () => {
      observer.disconnect();
    };
  }, [isXsScreen]);

  const containerClasses = classNames("spark-filter__footer", {
    "spark-filter__footer--floating":
      isFloating && isXsScreen && withApplyButton,
  });

  return (
    <>
      <div className={containerClasses}>
        {filterModulesCount > showFewFiltersCountInternal && !isXsScreen ? (
          <>
            <Button
              className={viewMoreClasses}
              textOnly
              onClick={onToggleMoreFiltersClick}
            >
              {showMoreFiltersText}
              <span className="spark-filter__toggle-caret"></span>
            </Button>
            <Button
              className={viewLessClasses}
              textOnly
              onClick={onToggleMoreFiltersClick}
            >
              {showFewerFiltersText}
              <span className="spark-filter__toggle-caret"></span>
            </Button>
          </>
        ) : null}

        <nav className="spark-btn-group spark-filter__apply-btn-container">
          {!isXsScreen && footerButtons}
          {withApplyButton ? (
            <Button
              size={isXsScreen ? "md" : "sm"}
              className={applyButtonClasses}
              onClick={onApplyFiltersInternal}
            >
              {applyButtonText}
            </Button>
          ) : null}
        </nav>
      </div>
      {isXsScreen && (
        <>
          <div ref={sentinelRef} />
          {footerButtons && (
            <div className="spark-mar-1 spark-mar-t-0 spark-pad-b-1">
              {footerButtons}
            </div>
          )}
          <FilterApplyButtonMobileCss />
        </>
      )}
    </>
  );
};

export default FilterFooter;
